import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import ElevenLabsWidget from './components/ElevenLabsWidget';
import Home from './pages/Home';
import ForCorporates from './pages/ForCorporates';
import ForInstitutes from './pages/ForInstitutes';
import ForIndividuals from './pages/ForIndividuals';
import Integrations from './pages/Integrations';
import AboutUs from './pages/AboutUs';
import Careers from './pages/Careers';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import CookiePolicy from './pages/CookiePolicy';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Research from './pages/Research';
import ResearchPaperDetail from './pages/ResearchPaperDetail';
import Login from './pages/admin/Login';
import Dashboard from './pages/admin/Dashboard';
import Editor from './pages/admin/Editor';
import OrganizationJsonLd from './components/OrganizationJsonLd';
import NotFound from './pages/NotFound';

function App() {
  return (
    <Router>
      <OrganizationJsonLd />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/for-corporates" element={<ForCorporates />} />
        <Route path="/for-institutes" element={<ForInstitutes />} />
        <Route path="/for-individuals" element={<ForIndividuals />} />
        <Route path="/integrations" element={<Integrations />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/contact" element={<Contact />} />
        {/* Primary privacy policy route: underscore (canonical) */}
        <Route path="/privacy_policy" element={<PrivacyPolicy />} />
        {/* Legacy hyphen route redirects to canonical underscore route */}
        <Route path="/privacy-policy" element={<Navigate to="/privacy_policy" replace />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/research" element={<Research />} />
        <Route path="/research/:slug" element={<ResearchPaperDetail />} />
        <Route path="/admin" element={<Login />} />
        <Route path="/admin/login" element={<Login />} />
        <Route path="/admin/dashboard" element={<Dashboard />} />
        <Route path="/admin/editor" element={<Editor />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <ElevenLabsWidget />
    </Router>
  );
}

export default App;
